import { investmentSectorData } from "../../config/homePageUtils";
import { useLanguage } from "../LanguageProvider/LanguageProvider";

const InvestmentSectorSection = () => {
  const { heading, highlightColor, items } = investmentSectorData;
  const { language } = useLanguage();
  return (
    <section
      id="investment-sector"
      className="bg-cover bg-center py-4 sm:py-4 md:py-4 section-bg investment-sector"
    >
      <div className="container mx-auto px-4 text-center hidden">
        {/* Heading */}
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-6">
          {language ? heading.hi : heading.en}
          <div
            className="mx-auto mt-2 h-1 w-16 sm:w-20 bg-[#FF9810]"
          />
        </h2>

        {/* Grid */}
        <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 mt-8">
          {items.map((sector, idx) => (
            <div
              className="bg-white rounded-lg p-4 shadow-md border-t-4 border-[#018f9b] 
         hover:shadow-lg transition-all duration-300 
         flex flex-col h-full wow fadeInDown"
            >
              <div className="relative group overflow-hidden mb-3">
                <img
                  src={sector.img}
                  alt={sector.alt}
                  className="rounded w-full h-40 object-cover transform transition-transform duration-300 group-hover:scale-110"
                ></img>
              </div>

              <div className="flex-grow">
                <h3 className="text-lg font-semibold text-left mb-1">
                  {language ? sector.title.hi : sector.title.en}
                </h3>
                <p className="text-sm text-gray-800 text-left">
                  {language ? sector.description.hi : sector.description.en}
                </p>
              </div>

              <button
                onClick={() => window.open(`${sector.url}`, "_blank")}
                className="mt-2 w-full rounded-md text-white text-sm font-semibold 
               bg-[#04636b] p-2 hover:bg-[#04636b]/80"
              >
                {language ? "डाउनलोड करें" : "Download"}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InvestmentSectorSection;
